
import React, { Component } from 'react';
import EdiaryResponseService from "../../services/ediaryResponse.service";
import EdiaryResponseSelectionService from "../../services/ediaryResponseSelection.service";
import ResponseDownloadForm from './EdiaryResponseDownloadNqForm';
import  GetErrorMessage  from '../../helpers/error-message'
import {ShowError, ShowSuccess} from "../../components/toast"
import {BlockUi} from 'app/components/Basics/';
import './EdiaryResponseDownloadNqComponent.scss';

class ResponseDownload extends Component {
	constructor (props) {
	super(props);
		this.state = {			
			loading: false,
			loadingMetaData: true,
			errorMessage: null,
			selectedSelectionFilters: null,			
			uiBlocked: false,
			mySavedFilters: [],
			metadata: {
				questions: [],
				regions: [],
				lastImportDate: ""
			}		
		}		
	}

	componentDidMount() {		
		this.queryMetadata();
		this.queryMySelectionFilters();
	}

	queryMySelectionFilters() {		
		EdiaryResponseSelectionService.find()
				.then(response =>{					
					this.setState({
						mySavedFilters: response.data					
					});
					return response;          
				})
				.catch(error => {			  
					let errorMessage = GetErrorMessage(error);
					console.log("errorMessage on catch");
					console.log(errorMessage);
					this.setState({ loading: false, errorMessage: errorMessage});            
			})
	}

	queryMetadata() {
		this.toggleUiBlock(true);
		EdiaryResponseService.getMetadata()
				.then(response =>{		
					console.log(response)			
					this.setState({
						metadata: response.data,
						loadingMetaData: false
					});
					this.toggleUiBlock(false);
					return response;          
				})
				.catch(error => {			  
					this.toggleUiBlock(false);
					let errorMessage = GetErrorMessage(error);
					console.log("errorMessage on catch");
					console.log(errorMessage);
					this.setState({ loading: false, errorMessage: errorMessage});            
			})
	}
	
	queryResponseDownload(term) {
		this.setState({ loading: true, filteredData: [] });
		const _this = this;
		EdiaryResponseService.find(term)
			.then(response =>{				
				this.setState({ filteredData: response.data,
					allData:  response.data,					
					loading: false				
				}, function() { this.filterResponseDownloads(this.state.search); });
				return response;          
			})
			.catch(error => {			  
				let errorMessage = GetErrorMessage(error);
				console.log("errorMessage on catch");
				console.log(errorMessage);
				this.setState({ loading: false, errorMessage: errorMessage});            
			})
	}	

	toggleUiBlock(blockUi) {
		this.setState ({uiBlocked: blockUi});
	}

	updateSelectedResponseDownloadFilters(selectedSelectionFilters) {		
		this.setState({selectedSelectionFilters: selectedSelectionFilters})
	}
	
    render() {

        return (
			<BlockUi tag="div" blocking={this.state.uiBlocked}>  
			<main className="app-body">

				<div className="app-content scrollbox">
					{this.state.loadingMetaData === false && (<ResponseDownloadForm
						toggleUiBlock={this.toggleUiBlock.bind(this)} 
						selectedSelectionFilters={this.state.selectedSelectionFilters}
						updateSelectedSelectionFilters={this.updateSelectedResponseDownloadFilters.bind(this)}
						metadata={this.state.metadata}
						mySavedFilters={this.state.mySavedFilters}
						queryMySelectionFilters={this.queryMySelectionFilters.bind(this)}
					/>)}
				</div>
				{this.state.successMessageFolder && ( <ShowSuccess clearMessage={() => this.setState({successMessageFolder: ''})} message={this.state.successMessageFolder} /> )}
				{this.state.errorMessage && ( <ShowError clearErrorMessage={() => this.setState({errorMessage: ''})} errorMessage={this.state.errorMessage} /> )}				
			</main>
			</BlockUi>
        );
    }
}

export default ResponseDownload;